export default ['new_building', 'shareholder', 'secondary'];
